import { useNavigate } from "react-router-dom";
import { APIClient, initializeApiClient } from "../utils/api/apiClient";
import { IMPERSONATION_KEYS } from "../utils/Common/impersonation";
import { logoutUser } from "../services/authService";
import { registerFCMToken } from "../services/notificationService";

const useSwitchBackToAdmin = () => {
  const navigate = useNavigate();

  const switchBackToAdmin = async () => {
    // End the impersonated session on the backend before anything else —
    // uses the impersonated user's own token/refreshToken, still active here.
    // This must run regardless of whether the admin-restore stash below is
    // intact, since the backend logout doesn't depend on it.
    const impersonatedRefreshToken = localStorage.getItem("refreshToken");
    if (impersonatedRefreshToken) {
      try {
        await logoutUser(impersonatedRefreshToken);
      } catch {
        // Ignore — still restore the admin session locally regardless.
      }
    }

    const adminToken = localStorage.getItem(IMPERSONATION_KEYS.ADMIN_TOKEN);
    const adminRole = localStorage.getItem(IMPERSONATION_KEYS.ADMIN_ROLE);
    const adminRefreshToken = localStorage.getItem(
      IMPERSONATION_KEYS.ADMIN_REFRESH_TOKEN,
    );
    const adminUser = localStorage.getItem(IMPERSONATION_KEYS.ADMIN_USER);

    if (!adminToken || !adminRole) return;

    localStorage.setItem("token", adminToken);
    localStorage.setItem("refreshToken", adminRefreshToken ?? "");
    localStorage.setItem("role", adminRole);
    if (adminUser) localStorage.setItem("user", adminUser);
    localStorage.setItem("authChanged", Date.now().toString());

    localStorage.removeItem(IMPERSONATION_KEYS.ADMIN_TOKEN);
    localStorage.removeItem(IMPERSONATION_KEYS.ADMIN_REFRESH_TOKEN);
    localStorage.removeItem(IMPERSONATION_KEYS.ADMIN_ROLE);
    localStorage.removeItem(IMPERSONATION_KEYS.ADMIN_USER);
    localStorage.removeItem(IMPERSONATION_KEYS.FLAG);

    APIClient.setApiToken(adminToken);
    APIClient.setRole(adminRole);
    initializeApiClient(adminRole);

    // Re-associate this device's push token with the admin again.
    const fcmToken = localStorage.getItem("fcm_token");
    if (fcmToken) {
      registerFCMToken(fcmToken, true).catch(() => {});
    }

    window.dispatchEvent(new CustomEvent("auth-ready"));

    navigate("/admin", { replace: true });
  };

  return { switchBackToAdmin };
};

export default useSwitchBackToAdmin;
